import { CodeBase } from "./_codeBase";

/**
 * アカウントロック区分
 */
export class AccountLockDiv extends CodeBase<AccountLockDiv>
{

    /** アカウントロック区分: "01", "ロック状態でない場合" */
    //空文字だとSpreadのコンボボックスが機能しないようである
    //public static readonly UNLOCK: AccountLockDiv = new AccountLockDiv("01", "ロック状態でない場合",'');
    //#862 Text値未設定のコンボボックスについて(空文字問題解消)
    //public static readonly UNLOCK: AccountLockDiv = new AccountLockDiv("01", "ロック状態でない場合", '-');
    public static readonly UNLOCK: AccountLockDiv = new AccountLockDiv("01", "ロック状態でない場合", '');

    /** アカウントロック区分: "02", "ロック状態の場合" */
    public static readonly LOCK: AccountLockDiv = new AccountLockDiv("02", "ロック状態の場合", '○');

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): AccountLockDiv[] {
        return [
            AccountLockDiv.UNLOCK,
            AccountLockDiv.LOCK,
        ];
    }
}
